import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM8.37109 16.1963L7.93457 18.6709C7.90124 18.8573 8.04552 19.0273 8.2334 19.0273L8.23535 19.0254H10.4414C10.5881 19.0251 10.7135 18.9192 10.7393 18.7754L11.1943 16.1963H8.37109ZM9.54688 9.53906L8.46094 15.6963H11.2832L12.3682 9.53906H9.54688ZM9.63379 9.04199H18.0254C18.1722 9.04347 18.2984 8.93773 18.3242 8.79395L18.7168 6.57129C18.7501 6.38496 18.6058 6.21489 18.418 6.21484L10.1338 6.21387L9.63379 9.04199ZM7.05957 6.21191C6.9126 6.21191 6.7865 6.31798 6.76074 6.46191L6.36816 8.68457C6.33483 8.87093 6.47911 9.04102 6.66699 9.04102H9.12891L9.62695 6.21191H7.05957Z"}}]};

const LogoTdesignFilled = Vue.extend<IconProps>({
  name: 'LogoTdesignFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-tdesign-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoTdesignFilled;
